import {CHANGE_SETTING} from "../actions/type";

const initialState = {
    language : "fa_IR",
    time_zone : "Asia/Tehran",
    posh_notification : 0,
    currency: "IRR",
};

export default function setting(state = initialState , action = {}) {
    switch (action.type) {
        case CHANGE_SETTING :
            const { setting } = action;
            return {
                language : setting.language,
                time_zone : setting.time_zone,
                posh_notification : setting.posh_notification,
                currency: setting.currency,
            };
        default:
            return state;
    }
};